import React, { useState, useEffect } from "react";
import { API_URL } from "../../../../../constants";
import { GetServiceCaller } from "../../../../../services/serviceCaller";
import Pagination from "../../../../../components/Pagination";
import { Table } from "react-bootstrap";
import moment from "moment";

const AmendmentLogs = (props) => {
  const [history, setHistory] = useState([]);
  const [rows, setRows] = useState([]);
  const itemsPerPages = 5;
  const [currentPage, setCurrentPage] = useState(1);

  const totalItems = history.length;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Calculate the indices for slicing the history data
  const indexOfLastItem = currentPage * itemsPerPages;
  const indexOfFirstItem = indexOfLastItem - itemsPerPages;
  const currentItems = history.slice(indexOfFirstItem, indexOfLastItem);

  const fetchCandidateDetails = async (id) => {
    const url = API_URL + "candidateprocess/" + id;
    try {
      let response = await GetServiceCaller(url);
      setHistory(response?.data?.data?.amandment_log);
    } catch (error) {
      console.error("Error fetching candidate details:", error);
    }
  };
  useEffect(() => {
    fetchCandidateDetails(props?.candidateID);
  }, [props.candidateID]);

  const addRow = () => {
    const currentRowIndex = rows.length - 1;
    const currentRow = rows[currentRowIndex];

    setRows([...rows, ["", "", "", "", "", ""]]);
  };

  const deleteRow = (index) => {
    const updatedRows = [...rows];
    updatedRows.splice(index, 1);
    setRows(updatedRows);
  };

  const handleChanged = (value, rowIndex, colIndex) => {
    const updatedRows = [...rows];
    updatedRows[rowIndex][colIndex] = value;
    setRows(updatedRows);
  };

  return (
    <div>
      <div className="table-responsive poc-head rounded mt-2">
        <Table striped bordered hover>
          <thead id="thcolor" className="text-center">
            <tr className="head">
              <th className="text-center">Sr. No.</th>
              <th className="text-center">Field Name</th>
              <th className="text-center">Previous</th>
              <th className="text-center">Updated</th>
              <th className="text-center">Updated Date</th>
              <th className="text-center">Updated By</th>
            </tr>
          </thead>
          <tbody className="border-bottom">
            {currentItems.map((log, index) => (
              <tr key={index}>
                <td className="text-center">{index + 1}</td>
                <td className="text-start">{log.fieldName}</td>
                <td className="text-start">{log.previous}</td>
                <td className="text-start">{log.updated}</td>
                <td className="text-center">
                  {log.updatedDate
                    ? moment(log.updatedDate, "DD-MM-YYYY").isValid()
                      ? moment(log.updatedDate, "DD-MM-YYYY").format(
                          "DD-MMM-YYYY"
                        )
                      : ""
                    : ""}
                </td>
                <td className="text-start">{log.updatedBy?.Name}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        <div className="d-flex justify-content-end">
          <Pagination
            itemsPerPage={itemsPerPages}
            totalItems={totalItems}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};

export default AmendmentLogs;
